import { render } from "./AdPreview.vue?vue&type=template&id=c67d94c4"
import script from "./AdPreview.vue?vue&type=script&lang=js"
export * from "./AdPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/AdPreview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c67d94c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c67d94c4', __exports__)) {
    api.reload('c67d94c4', __exports__)
  }
  
  module.hot.accept("./AdPreview.vue?vue&type=template&id=c67d94c4", () => {
    api.rerender('c67d94c4', render)
  })

}


export default __exports__